window.GoogleMapFactory = {
  build() {
    document.querySelectorAll("[data-google-map-app]").forEach((element) => {
      const rawMarkers = element.getAttribute("data-markers");

      try {
        new window.TerminalsLocationApp(element, JSON.parse(rawMarkers || "[]"));
      } catch (_error) {
        console.warn("Invalid marker payload for Google Maps widget.");
      }
    });
  },
};
